<template>
  <div>
    <Dialog
      :key="mainDialogKey"
      :visible.sync="opportunitySelectionDialog1"
      :style="{ width: '800px', height: '600px', overflowY: 'auto' }"
      :modal="true"
      :closable="true"
      :closeOnEscape="true"
      header="Enquiry Selection"
      class="p-fluid"
      :maximizable="true"
    >
      <template>
        <span class="p-input-icon-left">
          <i class="pi pi-search" />
          <InputText
            v-model="filters['global']"
            placeholder="Global Search"
            style="margin-right: 0.5em"
            @input="updateSearch"
          />
        </span>
      </template>

      <Message v-for="msg of messages" severity="info" :key="msg.content">
        {{ msg }}
      </Message>

      <!-- <div
        :style="{ height: '400px' }"
      > -->
      <DataTable
        :value="opportunities3"
        :filters="filters"
        :selection.sync="selectedOpportunity"
        @row-select="onRowSelect"
        dataKey="oppId"
        class="p-datatable-striped p-datatable-sm p-datatable-gridlines p-datatable-customers p-my-4"
        :scrollable="true"
        scrollHeight="200px"
        :loading="loading"
        :lazy="true"
        :rows="20"
        :virtualScroll="true"
        :virtualRowHeight="45"
        @virtual-scroll="onVirtualScroll"
        :totalRecords="lazyTotalRecords"
        selectionMode="single"
      >
        <template #header>
          Enquiries
        </template>

        <Column
          field="sQuoteNo"
          header="S Quote No"
          :sortable="true"
          headerStyle="width: 5em; text-align: center"
        >
          <template #loading>
            <span class="loading-text"></span>
          </template>
        </Column>
        <Column
          field="oppDescription"
          header="Opp description"
          :sortable="true"
          headerStyle="width: 15em; text-align: center"
        >
          <template #loading>
            <span class="loading-text">loading</span>
          </template>
        </Column>
        <Column
          field="address4"
          header="Address"
          :sortable="true"
          headerStyle="width: 7em; text-align: center"
        >
          <template #loading>
            <span class="loading-text">loading</span>
          </template>
        </Column>
        <Column
          field="custName"
          header="Customer"
          :sortable="true"
          headerStyle="width: 7em; text-align: center"
        >
          <template #loading>
            <span class="loading-text"></span>
          </template>
        </Column>
        <Column
          field="oppStatusName"
          header="Status"
          :sortable="true"
          headerStyle="width: 7em; text-align: center"
        >
          <template #body="slotProps">
            <span :class="'ignore pointer badge ' + getStyle(slotProps.data)">
              {{ slotProps.data.oppStatusName }}
            </span>
          </template>
          <template #loading>
            <span class="loading-text"></span>
          </template>
        </Column>
      </DataTable>
      <!-- </div> -->

      <template #footer>
        <Button
          class="p-button-success p-mr-2"
          label="Select"
          @click="select"
          style="width: auto"
        />
        <Button
          class="p-button-secondary p-mr-2"
          label="Cancel"
          @click="$emit('close')"
          style="width: auto"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import OpportunityService from "@/service/OpportunityService";

export default {
  name: "OpportunitySelection",
  props: {
    opportunitySelectionDialog: {
      type: Boolean,
      requrired: false
    },
    opportunities: {
      type: Array,
      required: false
    }
  },
  data: () => ({
    opportunityService: new OpportunityService(),
    lazyTotalRecords: 0,
    allOpportunities: [],
    opportunities1: [],
    opportunities2: null,
    opportunities3: [],
    selectedOpportunity: {},
    filters: {},
    messages: [],
    mainDialogKey: 0,
    requesting: false
  }),
  computed: {
    loading() {
      if (this.opportunities2 && this.opportunities2[0]) {
        return false;
      } else {
        if (this.requesting) {
          return true;
        } else {
          return false;
        }
      }
    },
    opportunitySelectionDialog1: {
      set(val) {
        if (!val) {
          this.$emit("close");
        }
      },
      get() {
        if (this.opportunitySelectionDialog) {
          this.setupOpportunities();
          return true;
        } else {
          return false;
        }
      }
    }
  },
  created() {
    this.setupOpportunities();
  },
  watch: {
    opportunities2(val) {
      if (val && val[0]) {
        this.opportunities3 = this.loadChunk(0, 40);
        this.lazyTotalRecords = val.length;
      }
    }
  },
  methods: {
    setupOpportunities() {
      if (this.opportunities) {
        this.opportunities1 = this.opportunities;
        this.opportunities2 = this.opportunities;
      } else {
        this.getAllOpportunities();
      }
      this.mainDialogKey++;
    },
    getStyle(data) {
      // according to: https://www.w3schools.com/bootstrap4/tryit.asp?filename=trybs_badges2&stacked=h
      // if (data && data.opportunityStatus && data.opportunityStatus.colourCode) {
      //   return data.opportunityStatus.colourCode
      // } else
      if (
        data &&
        data.oppStatusName &&
        data.oppStatusName.toLowerCase() === "lost"
      ) {
        return "badge-danger";
      } else if (
        data &&
        data.oppStatusName &&
        data.oppStatusName.toLowerCase() === "otp"
      ) {
        return "badge-info";
      } else if (
        data &&
        data.oppStatusName &&
        data.oppStatusName.toLowerCase() === "cancelled"
      ) {
        return "badge-light";
      } else if (
        data &&
        data.oppStatusName &&
        data.oppStatusName.toLowerCase() === "won"
      ) {
        return "badge-success";
      } else if (
        data &&
        data.oppStatusName &&
        data.oppStatusName.toLowerCase() === "tender"
      ) {
        return "badge-warning";
      } else {
        return "badge-dark";
      }
    },
    loadChunk(index, length) {
      let chunk = [];
      for (let i = 0; i < length; i++) {
        chunk[i] = this.opportunities2[index + i];
      }
      return chunk;
    },
    getAllOpportunities() {
      if (this.allOpportunities && this.allOpportunities[0]) {
        this.opportunities1 = this.allOpportunities;
        this.opportunities2 = this.allOpportunities;
      } else {
        this.requesting = true;
        this.opportunityService
          .getAllOpportunities()
          .then(data => {
            this.requesting = false;

            this.allOpportunities = data;
            this.opportunities1 = data;
            this.opportunities2 = data;
          })
          .catch(e => {
            this.requesting = false;

            this.$store.dispatch("addErrorMessage", {
              severity: "error",
              content: 'Some data was not loaded from "opportunities"'
            });
          });
      }
    },
    updateSearch(e) {
      if (!e) {
        this.opportunities2 = this.opportunities1;
      } else {
        var a = [];
        this.opportunities1.forEach(opportunity => {
          let b = Object.keys(opportunity);
          for (let i = 0; i < b.length; i++) {
            if (
              opportunity[b[i]] &&
              typeof opportunity[b[i]] === "string" &&
              opportunity[b[i]].search(e) >= 0
            ) {
              a.push(opportunity);
              break;
            }
          }
        });
        //
        this.opportunities2 = a;
      }
    },
    onRowSelect(event) {
      this.selectedOpportunity = event.data;
    },
    onVirtualScroll(event) {
      setTimeout(() => {
        //last chunk
        if (event.first === this.lazyTotalRecords - 40)
          this.opportunities3 = this.loadChunk(event.first, 40);
        else this.opportunities3 = this.loadChunk(event.first, event.rows);
      }, 250);
    },
    select() {
      if (this.selectedOpportunity)
        this.$emit("selected", this.selectedOpportunity);
    }
  }
};
</script>

<style scoped>
.pointer {
  font-size: 15px;
}
</style>
